import PlayerStateRepository from './player-state';
import EventBus from './event-bus';
import AnalyticsProvider from './analytics';
import BaseCoreController from './base-core.controller';

interface iFrameControllerConfig {
    alwaysCollapseControlBarOnIdle: boolean;
    sourceUrl: string;
    eventBus: EventBus;
    playerStateRepository: PlayerStateRepository;
}

export default class IFrameCoreController extends BaseCoreController {
    private timer?: number;

    private start?: number;

    private analytics?: AnalyticsProvider;

    private src: string;

    constructor({
        sourceUrl,
        eventBus,
        playerStateRepository,
        alwaysCollapseControlBarOnIdle
    }:iFrameControllerConfig) {
        super(eventBus, playerStateRepository, alwaysCollapseControlBarOnIdle);

        this.src = sourceUrl;
    }

    public async init(): Promise<void> {
        this.wasInitialized = true;
        if (this.src) {
            this.start = Date.now();
            this.timer = setInterval(() => {
                if (!this.start) {
                    return;
                }
                this.playerStateRepository.setState({
                    videoElapsedSecs: Math.floor((Date.now() - this.start) / 1000)
                });
            }, 1000);
            // autoplay iframes to trigger analytics
            this.playerStateRepository.setState({
                isPlaying: true
            });
        }
    }

    public tryAutoplay(): void {
        // not needed
    }

    public dispose(): void {
        super.dispose();
        clearInterval(this.timer);
    }
}
